import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://api.previewtax.com',
  // baseURL: "http://localhost:3000",
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;